import { Logo } from "./Logo";

export const TrustedByLogos = () => (
  <div className="grid grid-cols-3 gap-8">
    <Logo company="Notion" className="h-8 opacity-20" />
    <Logo company="Adobe" className="h-8 opacity-20" />
    <Logo company="Webflow" className="h-8 opacity-20" />
    <Logo company="SpaceX" className="h-8 opacity-20" />
  </div>
);
